import React, { Fragment, memo } from 'react';
import dynamic from 'next/dynamic';
import { Loader } from '@/components';

import styles from './Filters.module.scss';

const FilterRange = dynamic(() => import('./FilterRange'), {
	loading: () => <Loader />,
});

const Help = dynamic(() => import('../help'), {
	loading: () => <Loader />,
});

const FilterMultipleCollapsableSearchable = dynamic(
	() => import('./FilterMultipleCollapsableSearchable'),
	{
		loading: () => <Loader />,
	},
);

const FiltersTitleWithDescription = memo(({ title, description }) => {
	const words = title.split(' ');
	const lastWord = words[words.length - 1];
	const otherWords = words.slice(0, -1).join(' ');

	return (
		<div className={styles.title}>
			{description ? (
				<>
					{otherWords}{' '}
					<div className='with-description'>
						{lastWord}

						<Help>
							<h2>{title}</h2>
							<p>{description}</p>
						</Help>
					</div>
				</>
			) : (
				title
			)}
		</div>
	);
});

const Filters = memo(({ filters, onChange, selectedFilters, isSearchPage = false }) => {
	return (
		<div className={styles.container}>
			{filters.map(({ type, id, slug, name: title, options: items, info }, index) => {
				switch (type) {
					case 'checkbox':
						return (
							<Fragment key={id || index}>
								{items?.length && (
									<section className={styles.section}>
										<div className={styles.block}>
											{title && slug !== 'mark' && (
												<FiltersTitleWithDescription title={title} description={info} />
											)}
											<FilterMultipleCollapsableSearchable
												name={slug}
												items={items}
												selectedFilters={selectedFilters}
												onChange={onChange}
												isSearchPage={isSearchPage}
												title={title}
											/>
										</div>
									</section>
								)}
							</Fragment>
						);
					case 'range':
						return (
							<section className={styles.section} key={id || index}>
								{title && <FiltersTitleWithDescription title={title} description={info} />}
								<FilterRange
									name={slug}
									onChange={onChange}
									selectedFilters={selectedFilters}
									isSearchPage={isSearchPage}
								/>
							</section>
						);
					default:
						return null;
				}
			})}
		</div>
	);
});

export default Filters;
